/**
 This script adds a custom class to wp-columns for color-cards.
 It serves the purpose of only allowing two columns per row for color-cards
**/

const colorCards = document.querySelectorAll('.colorcard');

if (colorCards) {
    let hasColumns = false;
    colorCards.forEach(card => {
       if (card.parentElement && card.parentElement.classList.contains('wp-block-column')) {
           card.parentElement.classList.add('max-width-half');
           hasColumns = true;
       }
    });

    if (hasColumns && colorCards[0] && colorCards[0].parentElement && colorCards[0].parentElement.parentElement) {
        colorCards[0].parentElement.parentElement.classList.add('flexwrap')
        colorCards[0].parentElement.parentElement.id = 'colorcard-columns';
    }
}